import PageTitle from "@alliancesafetycouncil/asc-page-title";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { getMusterLocation } from "../../../actions/Sites/Sites";
import FormContainer from "../../../components/FormContainer/FormContainer";
import EditMusterLocationForm from "./EditMusterLocationForm";

class EditMusterLocation extends Component {
  componentWillMount() {
    const { id, networkId } = this.props.match.params;

    this.props.GetMusterLocation(id, networkId);
  }

  render() {
    const { id, networkId } = this.props.match.params;

    const { data } = this.props;

    return (
      <div className="flex flex-1 flex-col">
        <Breadcrumb tag="nav" listTag="div">
          <BreadcrumbItem tag="a" href="#/muster-location" className="bread-crumb-root">
            Muster Location
          </BreadcrumbItem>
          <BreadcrumbItem>Add Location</BreadcrumbItem>
        </Breadcrumb>
        <PageTitle icon="gate">Edit Muster Location</PageTitle>
        <FormContainer
          {...this.props}
          entity="locations"
          action="edit"
          redirect={`/muster-location/location-details/${id}/${networkId}/details`}
          Form={EditMusterLocationForm}
          handleValues={(values) => {
            return {
              site: {
                id: values.site.id,
              },
              name: values.name,
              contacts: values.contacts,
              notes: values.notes,
              status: values.status,
            };
          }}
          site={data.site}
          initialValues={data}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.siteService.location,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetMusterLocation: (emergencyId, networkId) => dispatch(getMusterLocation(emergencyId, networkId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditMusterLocation);
